import Row from "antd/lib/row";
import "antd/lib/row/style/css";

export default Row;
